import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// points list
import { PointListPageComponent } from '../pages/list.component';

// point detail
import { PointDetailPageComponent } from '../pages/detail.component';
import { InspectionPointDetailComponent } from '../components/detail.component';

import { routedComponents, PointRoutingModule } from './point.routing';
import { SharedModule } from '../../shared.module';
import { PluginModule } from '../../plugins/modules';
import { PointMenuComponent } from '../../menus/point.menu';
import { BrowserSharedModule } from '../../browser-shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PluginModule,
    PointRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserSharedModule
  ],
  declarations: [
    routedComponents,
    PointListPageComponent,
    PointDetailPageComponent,
    InspectionPointDetailComponent,
    PointMenuComponent
  ],
  exports: [PointListPageComponent]
})
export class PointModule {}
